import { GET_ORGANIZATION } from "@/actions/GET_ORGANIZATION.ts";
import { Language } from "@/components/Inputs/LanguagePicker/Language.ts";
import { WarningToast } from "@/components/Notifications/WarningToast.tsx";
import { Organization, PaymentProviderEnum } from "@/helpers/types/types.ts";
import { getLocale } from "@/stores/ApolloClient/helpers/getLocale.ts";
import { useQuery } from "@apollo/client";
import { useEffect, useMemo } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

interface GetOrganizationResponse {
  currentOrganization: Organization;
}

export const useGetOrganization = () => {
  const { data, loading, error } = useQuery<GetOrganizationResponse>(GET_ORGANIZATION);

  const { i18n, t } = useTranslation();

  useEffect(() => {
    if (error) {
      console.error("GET_ORGANIZATION failed:", error.message);
      toast.custom(<WarningToast message={t("error")} />);
    }
  }, [error, t]);

  const paymentEnabled = useMemo(() => {
    return (
      data?.currentOrganization?.paymentType === PaymentProviderEnum.WsPay ||
      data?.currentOrganization?.paymentType === PaymentProviderEnum.WsPayPer
    );
  }, [data?.currentOrganization?.paymentType]);

  return {
    organization: data?.currentOrganization,
    getOrganizationLoading: loading,
    privacyPolicy:
      data?.currentOrganization?.translations?.find(
        (ot) => ot.language === getLocale(i18n.language as Language),
      )?.privacyPolicy || data?.currentOrganization?.privacyPolicy,
    termsAndConditions:
      data?.currentOrganization?.translations?.find(
        (ot) => ot.language === getLocale(i18n.language as Language),
      )?.termsAndConditions || data?.currentOrganization?.termsAndConditions,
    logoUrl: data?.currentOrganization?.logoUrl,
    organizationName: data?.currentOrganization?.name,
    paymentType: data?.currentOrganization?.paymentType,
    paymentEnabled,
  };
};
